import { gql } from "@apollo/client"
import {
  SELLABLE_ITEM_LIST_FRAG,
  SELLABLE_ITEM_DETAILS_FRAG,
  SELLABLE_ITEM_STOCK_DETAIL_FRAG,
  RELATED_STOCK_FRAG,
} from "./sellable-item.fragments.gql"

export const SELLABLE_ITEMS_LIST = gql`
  query SellableItemsList(
    $first: Int
    $skip: Int
    $query: String
    $filter: SellableItemFilterInput
  ) {
    allSellableItems(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      ...SellableItemListFrag
    }
  }
  ${SELLABLE_ITEM_LIST_FRAG}
`

export const SELLABLE_ITEMS_DETAIL = gql`
  query SellableItemsDetail($id: ID!) {
    sellableItemDetail(id: $id) {
      ...SellableItemDetailsFrag
    }
  }
  ${SELLABLE_ITEM_DETAILS_FRAG}
`

export const SELLABLE_ITEMS_STOCK_LIST = gql`
  query SellableItemsStockList(
    $first: Int
    $skip: Int
    $query: String
    $filter: SellableItemStockFilterInput
  ) {
    sellableItemStock(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      offerStockCount
      holdStockCount
      currentStockCount
      bookedStockCount
      totalStockCount @client
      isLive
      rejectedStockCount
      groupVisibility {
        id
        name
      }
      distributionCentre {
        id
        name
        address {
          id
          village
          address
          district
        }
      }
      sellableItem {
        id
        codename
        shortDescription
        name
      }
    }
  }
`

export const SELLABLE_ITEM_STOCK_DETAIL = gql`
  query SellableItemStockDetail(
    $first: Int
    $skip: Int
    $query: String
    $filter: SellableItemStockFilterInput
  ) {
    sellableItemStock(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      ...SellableItemStockDetailFrag
    }
  }
  ${SELLABLE_ITEM_STOCK_DETAIL_FRAG}
`

export const SELLABLE_ITEMS_SUGGEST = gql`
  query SellableItemsSuggest(
    $first: Int
    $skip: Int
    $query: String
    $filter: SellableItemFilterInput
    $distributionCentreId: ID
  ) {
    allSellableItems(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      id
      name
      codename
      sellableVarieties {
        id
        variety {
          id
          primaryGroup {
            id
            name
          }
        }
      }
      sellableStocks(distributionCentreId: $distributionCentreId) {
        id
        currentStockCount
        holdStockCount
        rejectedStockCount
        bookedStockCount
        offerStockCount
      }
    }
  }
`

export const RELATED_STOCKS = gql`
  query RelatedStocks($sellableItem: ID) {
    sellableItemStock(filter: { sellableItem: $sellableItem }) {
      ...RelatedStockFrag
    }
  }
  ${RELATED_STOCK_FRAG}
`

export const ALL_BATCH_STOCKS = gql`
  query allBatchStocks($filter: BatchStockFilterInput) {
    allBatchStocks(filter: $filter) {
      id
      codename
      manufacturedOn
      manufacturedBy {
        id
        name
      }
      suppliedBy {
        id
        name
      }
      expiryOn
      sku {
        id
        name
      }
      totalQuantity
      currentStockCount
      holdStockCount
      alternateStockCount
      intransitStockCount
      dumpedStockCount
      parentBatchStock {
        id
        codename
      }
      coaCertificate
    }
  }
`
